import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormControl} from '@angular/forms';
import {BehaviorSubject, Observable} from 'rxjs';
import {Unsubscribable} from '@core/interfaces/unsubscribable';
import {take, takeUntil} from 'rxjs/operators';
import {GeneralOption} from '@core/interfaces/system/system-common';

@Component({
    selector: 'ngx-radio-card',
    templateUrl: './radio-card.component.html',
    styleUrls: ['./radio-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RadioCardComponent extends Unsubscribable implements OnInit {
    @Input() inputDataList$: Observable<GeneralOption[]>;
    @Input() headerTitle: string;
    @Input() radioGroupTitle: string;
    @Input() tooltipMessage: string;
    @Input() resetToValue: BehaviorSubject<string | string[]> = new BehaviorSubject<string | string[]>(null);
    @Output() onInputChanges: EventEmitter<{current: string; previous: string}> = new EventEmitter();

    selectControl: FormControl = new FormControl(null);

    previousValue: BehaviorSubject<string> = new BehaviorSubject<string>(null);

    constructor() {
        super();
    }

    ngOnInit(): void {
        this.selectControl.valueChanges.pipe(takeUntil(this.unsubscribe$)).subscribe((input: string) => {
            this.onInputChanges.emit({current: input, previous: this.previousValue.value});

            this.previousValue.next(input);
        });

        this.resetToValue
            .asObservable()
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe((value: string) => this.setDefaultOption(value));
    }

    setDefaultOption(value?: string) {
        if (value) this.selectControl.setValue(value, {emitEvent: false});
        else
            this.inputDataList$
                .pipe(take(1))
                .subscribe((options: GeneralOption[]) => this.selectControl.setValue(options[0]?.value));
    }
}
